<template>
  <el-col :span="24">
    <div class="content"> <span>{{content}}</span></div>
    <div
      class="action"
      v-if="scope.row.interactiveCount"
    >
      <div
        v-for="item in actionList"
        :key="item.id"
        @click="actionShow"
      >
        <ig-icon :name="item.icon"></ig-icon>
        <span>{{item.value}}</span>
      </div>
    </div>
  </el-col>
</template>

<script>
export default {
  name: "contentandaction",
  props: {
    tableData: Object,
    scope: Object
  },
  data() {
    return {};
  },
  computed: {
    content() {
      return this.scope.row[this.tableData.bind];
    },
    actionList() {
      let list = [];
      this.tableData.binds.forEach(item => {
        list.push({
          id: item.id,
          bind: item.bind,
          value: this.scope.row[item],
          icon: item.icon
        });
      });
      return list;
    }
  },
  methods: {
    actionShow() {
      this.$emit("actionShow", this.scope.row);
    }
  },
  components: {}
};
</script>

<style scoped lang="scss">
.content {
  width: 100%;
  height: 66px;
  line-height: 22px;
  font-size: 14px;
  color: #333;
  display: flex;
  justify-content: center;
  align-items: center;
  span {
    /* 自动换行 */
    word-break: break-all;
    /* 多行溢出隐藏 */
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    overflow: hidden;
  }
}
.action {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #666;
  font-size: 14px;
  user-select: none;
  cursor: pointer;
  i {
    margin-right: 10px;
    color: #666;
  }
}
</style>
